export default "__VITE_ASSET__BAOi5E1i__"